
import React, { useEffect } from 'react';

export type ToastType = 'success' | 'error' | 'info';

interface ToasterProps {
  message: string;
  type: ToastType;
  onClose: () => void;
}

const Toaster: React.FC<ToasterProps> = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const bgColors = {
    success: 'bg-accent/10 border-accent/30 text-accent',
    error: 'bg-red-500/10 border-red-500/30 text-red-500',
    info: 'bg-blue-500/10 border-blue-500/30 text-blue-400',
  };

  return (
    <div className="fixed top-6 left-1/2 -translate-x-1/2 z-[100] animate-in slide-in-from-top-4 duration-300">
      <div className={`px-6 py-3 rounded-2xl border shadow-2xl backdrop-blur-xl flex items-center gap-3 ${bgColors[type]}`}>
        <span className="text-xs font-bold uppercase tracking-widest">{message}</span>
      </div>
    </div>
  );
};

export default Toaster;
